<template>
  <m-layout-mask :key="change">
    <div class="view-layout" style="width: 100%; margin-top: -50px; height: 100%;">
      <div class="content-layout" style="width: 100%; margin-top: 0px; margin-bottom: 0px;">
        <m-scrollbar>
          <div class="caption" v-if="this.$i18n.locale === 'ru'">VIP-ставки</div>
          <div class="content" v-if="this.change === 'ru'">
            <p>1.VIP-ставка – ставка, сумма которой превышает текущий максимум на выбранный набор исходов.</p>

            <p>2.Время принятия компанией решения по VIP-заявке определяется от момента подачи запроса на VIP-ставку до начала ближайшего по времени события в ставке, и не превышает 10 минут.</p>

            <p>3.VIP-ставкой может быть одиночная ставка, экспресс или другая сложная ставка. На некоторые спортивные события заявки на VIP-ставки не принимаются. После определения результатов по всем исходам, входящим в VIP-ставку, она рассчитывается по обычным правилам.</p>

            <p>4.VIP-ставки не принимаются по ходу матчей.</p>
          </div>
        <div class="caption" v-if="this.$i18n.locale === 'en'">VIP-bets</div>
          <div class="content" v-if="this.change === 'en'">
            <p>1.VIP bet - a bet, the amount of which exceeds the current maximum on the selected set of outcomes.</p>

            <p>2. The time the company makes a decision on a VIP-application is determined from the moment of submitting a request for a VIP-rate to the beginning of the next event in the rate, and does not exceed 10 minutes.</p>

            <p>3.VIP bets can be single bets, multi bets or other compound bets. Some sporting events will not accept VIP bets. After determining the results for all selections included in the VIP bet, it is calculated according to the usual rules.</p>

            <p>4.VIP bets are not accepted during matches.</p>
          </div>
        <div class="caption" v-if="this.$i18n.locale === 'az'">VIP-mərclər</div>
          <div class="content" v-if="this.change === 'az'">
            <p>1. VIP mərc - mərc məbləği üçün seçilmiş maksimum məhdudiyyəti aşıb mərc edənlər üçün şirkətlə razılaşdırılaraq qoyulan mərclər hesab edilir.

            <p>2. Şirkətin VİP mərclə bağlı qərar vermə vaxtı, VIP mərc üçün sorğu göndərildiyi andan mərc edilən obyektin başlama vaxtına qədər olan ən azı 10 dəqiqə ərzində qəbul edilir.

            <p>3. VIP mərclər tək mərclər, çoxlu mərclər və ya digər qarışıq mərclər ola bilər. Bəzi idman tədbirləri üçün VIP mərclər qəbul edilməyəcək. VIP mərcinə daxil olan bütün nəticələr üçün nəticələr müəyyən edildikdən sonra, adi qaydalara əsasən hesablanır.</p>

            <p>4.VIP bahislər matçın gedişində qəbul edilmir.</p>
          </div>
        </m-scrollbar>
      </div>
    </div>
  <m-layout-mask>
</template>

<script>
import MLayoutMask from '@/components/layouts/MLayoutMask'
import MLayout from '@/components/layouts/MLayout'
import MWidgetHead from '@/components/widget/MWidgetHead'
import MScrollbar from '@/components/MScrollbar'

export default {
  components: { MLayoutMask, MLayout, MWidgetHead, MScrollbar },
  data () {
    return {
      change: this.$i18n.locale
    }
  },
  mounted () {
    this.change = this.$i18n.locale
  },
  watch: {
    '$i18n.locale' (to, from) {
      this.change = this.$i18n.locale
    }
  }
}
</script>

<style scoped>
.view-layout { height: 100%; }
.content-layout { height: 100%; margin-top: -40px; padding: 50px 0 10px; }
.content-widget-head { margin: 0 10px; width: 100%; text-align: center; }
.caption { font-size: 18px; text-align: center; margin-bottom: 15px; margin-top: 15px; border-bottom: 1px solid hsla(0,0%,100%,.07); }
.content p { margin: 5px 10px; }
li { margin-left: 10px; }
</style>



// WEBPACK FOOTER //
// src/components/vip/View.vue